<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" (ngSubmit)="save()">
    <div class="ir-modal--title">
      <div class="ir-line--right">
        <div class="ir-btn th-btn-modal" (click)="undoChanges()">
          <i class="material-icons">undo</i>
        </div>
      </div>
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'common.edit' | translate }} {{ 'plugins.add-photos.photo' | translate }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <ns-edit-image [inputImage]="inputImage" *ngIf="inputImage"></ns-edit-image>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            [disabled]="!points"
            type="submit"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
